import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { getCatalog } from '../../api/catalog';
import { categoryCover } from '../../utils/categoryCovers';
import { setSeoMeta, toAbsoluteUrl, upsertJsonLd, removeJsonLd } from '../../utils/seo';
import './Index.css';

export default function CatalogIndex() {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getCatalog();
        if (!mounted) return;
        setCats(Array.isArray(data) ? data.filter((c) => c?.slug) : []);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const canonical = toAbsoluteUrl('/catalog');
    setSeoMeta({
      title: 'Каталог сантехники LavSan',
      description: 'Каталог LavSan: сантехника для ванной и кухни по категориям.',
      canonical,
      og: { type: 'website', url: canonical },
    });

    upsertJsonLd('breadcrumb-catalog-index', {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Главная', item: toAbsoluteUrl('/') },
        { '@type': 'ListItem', position: 2, name: 'Каталог', item: canonical },
      ],
    });

    return () => removeJsonLd('breadcrumb-catalog-index');
  }, []);

  return (
    <div className="catalog-page container">
      <header className="catalog-page__head">
        <h1>Каталог</h1>
        <p>Выберите категорию, затем подкатегорию</p>
      </header>

      {loading ? (
        <div className="catalog-cats">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="catalog-cat is-skeleton" />
          ))}
        </div>
      ) : (
        <div className="catalog-cats">
          {cats.map((cat) => {
            const title = cat.name?.ru || cat.slug;
            const count = (cat.subcategories || []).length;
            const cover = categoryCover(cat.slug);
            return (
              <Link key={cat.slug} to={`/catalog/${cat.slug}`} className="catalog-cat">
                <div className="catalog-cat__media">
                  <img
                    src={cover}
                    alt={title}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.opacity = 0;
                    }}
                  />
                </div>
                <div className="catalog-cat__body">
                  <div className="catalog-cat__text">
                    <span className="catalog-cat__name">{title}</span>
                    <span className="catalog-cat__meta">
                      {count
                        ? `${count} подкатегор${count === 1 ? 'ия' : count < 5 ? 'ии' : 'ий'}`
                        : 'Раздел'}
                    </span>
                  </div>
                  <span className="catalog-cat__go" aria-hidden>
                    <FiArrowRight />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      )}

      {!loading && !cats.length && (
        <p className="catalog-empty">Категории пока не добавлены.</p>
      )}
    </div>
  );
}
